//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Rating, Typography } from '@backmarket/design-system'

import FormattedMessage from '@i18n/components/FormattedMessage'

import translations from './RateSection.translations'

export default {
  components: {
    FormattedMessage,
    Rating,
    Typography,
  },
  props: {
    globalRate: {
      type: Number,
      required: true,
    },
    totalReviews: {
      type: Number,
      required: true,
    },
  },
  computed: {
    translations: () => translations,
  },
}
